/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-11-17 11:10:23
 * @FilePath: \monitor\src\language\project\user.js
 * @Description: 
 */
const info = {
  CN: {
    newUser: "新建用户",
    editUser: "编辑用户",
    configurationItems: "配置项目",
    cancelBtn: "取消",
    saveBtn: "保存",
    number: "序号",
    status: "状态",
    registerTime: "注册时间",
    operation: "操作",
    adopt: "通过",
    edit: "编辑",
    config: "配置项目",
    zoneConfig: "区域配置",
    disable: "禁用",
    delete: "删除",  
    tips: "温馨提示",
    deleteTips: "删除操作不可恢复,是否继续删除该用户？",
    deleteSuccess: "删除成功",
    deleteError: "删除失败",
    validWarnText: "必填信息不能为空",
    addSuccess: "添加成功",
    addError: "添加失败",
    saveSuccess: "保存成功",
    saveError: "保存失败",
    editSuccess: "修改成功",
    editError: "修改失败",
    male: "男",
    female: "女",
    configurableItems: "可配置项目",
    configureditems: "已配置项目",
    zoneNotConfigured: "未配置区域",
    configuredZone: "已配置区域",
    configurationInformation: "获取配置信息失败",
    systemAdmin: "系统管理员",
    projectAdmin: "项目管理员",
    ordinaryUsers: "普通用户",
    userId: "登录名",
    userIdPla: "请输入登录名",
    userIdRules: "登录名不能为空",
    userName: "用户名称",
    userNamePla: "请输入用户名称",
    userNameRules: "用户名称不能为空",
    gender: "性别",
    genderPla: "请选择性别",
    genderRules: "性别不能为空",
    password: "密码",
    passwordPla: "请输入密码",
    passwordRules: "密码不能为空",
    role: "角色",
    rolePla: "请选择角色",
    projectPla: "请选择项目",
    roleRules: "角色不能为空",
    projectRules: "项目配置不能为空",
    unit: "单位",
    unitPla: "请输入单位",
    unitRules: "单位不能为空",
    duties: "职务",
    dutiesPla: "请输入职务",
    dutiesRules: "职务不能为空",
    email: "邮箱",
    emailPla: "请输入邮箱",
    emailRules: "邮箱不能为空",
    phone: "手机号码",
    phonePla: "请输入手机号码",
    phoneRules: "手机号码不能为空",
    normal: "正常",
    invalid: "无效",
    
  },
  EN: {
    newUser: "New User",
    editUser: "Edit User",
    configurationItems: "Configuration Items",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    number: "Number",
    status: "Status",
    registerTime: "Register Time",
    operation: "Operations",
    adopt: "adopt",
    edit: "edit",
    config: "config",
    zoneConfig: "Zone Configuration",
    disable: "disable",
    delete: "delete", 
    tips: "Tips",
    deleteTips: "The deletion operation is not recoverable. Do you want to continue deleting this user?",
    deleteSuccess: "Successfully deleted",
    deleteError: "Delete failed",
    validWarnText: "Required information cannot be empty",
    addSuccess: "Added successfully",
    addError: "Add failed",
    saveSuccess: "Successfully saved",
    saveError: "Save failed",
    editSuccess: "Successfully modified",
    editError: "Modification failed",
    male: "male",
    female: "female",
    configurableItems: "Configurable Items",
    configureditems: "Configured items",
    zoneNotConfigured: "Unconfigured zone",
    configuredZone: "Configured zone",
    configurationInformation: "Failed to obtain configuration information",
    systemAdmin: "system administrator",
    projectAdmin: "project administrator",
    ordinaryUsers: "ordinary users",
    userId: "Login Name",
    userIdPla: "Please input your login name",
    userIdRules: "Login name cannot be empty",
    userName: "User Name",
    userNamePla: "Please input your user name",
    userNameRules: "User name cannot be empty",
    gender: "Gender",
    genderPla: "Please select gender",
    genderRules: "Gender cannot be empty",
    password: "Password",
    passwordPla: "Please input the password",
    passwordRules: "Password cannot be empty",
    role: "Role",
    rolePla: "Please select a role",
    projectPla: "Please select a project",
    roleRules: "Role cannot be empty",
    projectRules: "Project configuration cannot be empty",
    unit: "Unit",
    unitPla: "Please input the unit",
    unitRules: "Unit cannot be empty",
    duties: "Duties",
    dutiesPla: "Please input the duties",
    dutiesRules: "Duties cannot be empty",
    email: "Email",
    emailPla: "Please input your email address",
    emailRules: "Email cannot be empty",
    phone: "Phone",
    phonePla: "Please input your phone",
    phoneRules: "Phone cannot be empty",
    normal: "normal",
    invalid: "invalid",

  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/project/user.js